import { toast } from "react-toastify";
import transactionalService from "../../api/transactionalService";
import * as actionTypes from "./actionTypes";

export const setClaveDobleFactorUsuario = (claveDobleFactorUsuario) => {
  return {
    type: actionTypes.LOAD_CLAVE_DOBLE_FACTOR_USUARIO,
    payload: { claveDobleFactorUsuario },
  };
};

export const getClaveDobleFactorUsuario = () => async (dispatch) => {
  try {
    dispatch(setLoadingClaveDobleFactorUsuario(true));
    const response = await transactionalService.listarClaveDobleFactor();
    dispatch(setClaveDobleFactorUsuario(response.data));
    dispatch(setLoadingClaveDobleFactorUsuario(false));
  } catch (error) {
    dispatch(setLoadingClaveDobleFactorUsuario(false));
    throw error;
  }
};

export const afiliacionCancelar = () => async (dispatch) => {
  try {
    const response = await transactionalService.afiliacionClaveSmsCancelar();
    //dispatch(setListaDobleFactor(response.data));
    toast.info(response.message);
    return response;
  } catch (error) {
    throw error;
  }
};

export const afiliacionVerificacion = (request) => async (dispatch) => {
  try {
    const response = await transactionalService.afiliacionClaveSmsVerificacion(
      request
    );
    toast.info(response.message);
    return response;
  } catch (error) {
    throw error;
  }
};

export const afiliacionConfirmacion = (request) => async (dispatch) => {
  try {
    const response = await transactionalService.afiliacionClaveSmsConfirmacion(
      request
    );
    toast.info(response.message);
    return response;
  } catch (error) {
    throw error;
  }
};

const setLoadingClaveDobleFactorUsuario = (loading) => {
  return {
    type: actionTypes.LOADING_CLAVE_DOBLE_FACTOR_USUARIO,
    payload: { loading },
  };
};

export const setLoadingGenerarClaveDobleFactor = (loading) => {
  return {
    type: actionTypes.LOADING_GENERAR_CLAVE_DOBLE_FACTOR,
    payload: { loading },
  };
};

export const setLoadingValidarClaveDobleFactor = (loading) => {
  return {
    type: actionTypes.LOADING_VALIDAR_CLAVE_DOBLE_FACTOR,
    payload: { loading },
  };
};

export const generarClaveDobleFactor = (request = { tipoProceso: 0 }) => async (
  dispatch
) => {
  try {
    dispatch(setLoadingGenerarClaveDobleFactor(true));
    const response = await transactionalService.generarClaveDobleFactor(
      request
    );
    dispatch(setLoadingGenerarClaveDobleFactor(false));
    return response;
  } catch (error) {
    dispatch(setLoadingGenerarClaveDobleFactor(false));
    throw error;
  }
};

export const validarClaveDobleFactor = (request) => async (dispatch) => {
  try {
    dispatch(setLoadingValidarClaveDobleFactor(true));
    const response = await transactionalService.validarClaveDobleFactor(
      request
    );
    dispatch(setLoadingValidarClaveDobleFactor(false));
    return response;
  } catch (error) {
    dispatch(setLoadingValidarClaveDobleFactor(false));
    throw error;
  }
};
